import { render } from "./LabelContentEditWidget.vue?vue&type=template&id=1f572837&ts=true"
import script from "./LabelContentEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./LabelContentEditWidget.ts?vue&type=script&lang=ts&external"

import "./LabelContentEditWidget.vue?vue&type=style&index=0&id=1f572837&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__